module.exports = __webpack_public_path__ + "static/media/shape0_4.fbb7df5f.obj";